"use client";

import { c as _c } from "react/compiler-runtime";
import { Close } from "@mui/icons-material";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useMatchBreakpoints } from "../../hooks";
import { Button, ButtonSize, ButtonVariant } from "../Button";
import { Input } from "../Input";
import { Text, TextColor, TextSize, TextWeight } from "../Text";
const RangeSliderContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
  height: 24px;
  display: flex;
  align-items: center;
`;
const SliderTrack = styled.div`
  position: absolute;
  width: 100%;
  height: 4px;
  background: #e3e4e5;
  border-radius: 2px;
`;
const SliderRange = styled.div`
  position: absolute;
  height: 4px;
  background: black;
  border-radius: 2px;
  left: ${({
  $left
}) => $left > 0 ? $left : 0}%;
  width: ${({
  $width
}) => $width}%;
`;
const RangeInput = styled.input`
  position: absolute;
  width: 100%;
  height: 4px;
  background: transparent;
  appearance: none;
  pointer-events: none;

  &::-webkit-slider-thumb {
    appearance: none;
    height: 20px;
    width: 20px;
    background: black;
    border-radius: 50%;
    cursor: pointer;
    pointer-events: all;
    position: relative;
    z-index: 3;
    border: none;
  }

  &::-moz-range-thumb {
    height: 20px;
    width: 20px;
    background: black;
    border-radius: 50%;
    cursor: pointer;
    border: none;
    pointer-events: all;
    box-sizing: border-box;
  }

  &::-webkit-slider-track {
    background: transparent;
    height: 4px;
  }

  &::-moz-range-track {
    background: transparent;
    height: 4px;
    border: none;
  }

  &:focus {
    outline: none;
  }
`;
const MinRangeInput = styled(RangeInput)`
  z-index: 1;
`;
const MaxRangeInput = styled(RangeInput)`
  z-index: 2;
`;
const Pricing = t0 => {
  const $ = _c(100);
  const {
    priceLabel,
    minPrice,
    maxPrice,
    currency: t1,
    showOnSaleOnly: t2,
    setShowOnSaleOnly,
    selectedMinPrice,
    selectedMaxPrice,
    setSelectedMinPrice,
    setSelectedMaxPrice,
    onApplyFilters,
    allSelectedColors,
    allSelectedSizes,
    currentFeatures
  } = t0;
  const currency = t1 === undefined ? "PLN" : t1;
  const showOnSaleOnly = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== selectedMinPrice) {
    t3 = selectedMinPrice?.toString() ?? "";
    $[0] = selectedMinPrice;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const [minInputValue, setMinInputValue] = useState(t3);
  let t4;
  if ($[2] !== selectedMaxPrice) {
    t4 = selectedMaxPrice?.toString() ?? "";
    $[2] = selectedMaxPrice;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const [maxInputValue, setMaxInputValue] = useState(t4);
  const [tempMinPrice, setTempMinPrice] = useState(selectedMinPrice);
  const [tempMaxPrice, setTempMaxPrice] = useState(selectedMaxPrice);
  const [tempOnSaleOnly, setTempOnSaleOnly] = useState(showOnSaleOnly);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const {
    isXs,
    isSm,
    isMd
  } = useMatchBreakpoints();
  const isMobile = isXs || isSm || isMd;
  let t5;
  let t6;
  if ($[4] !== isOpen || $[5] !== selectedMaxPrice || $[6] !== selectedMinPrice || $[7] !== showOnSaleOnly) {
    t5 = () => {
      if (isOpen) {
        setTempMinPrice(selectedMinPrice);
        setTempMaxPrice(selectedMaxPrice);
        setTempOnSaleOnly(showOnSaleOnly);
        setMinInputValue(selectedMinPrice?.toString() ?? "");
        setMaxInputValue(selectedMaxPrice?.toString() ?? "");
      }
    };
    t6 = [isOpen, selectedMinPrice, selectedMaxPrice, showOnSaleOnly];
    $[4] = isOpen;
    $[5] = selectedMaxPrice;
    $[6] = selectedMinPrice;
    $[7] = showOnSaleOnly;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[10] !== tempMinPrice) {
    t7 = () => {
      setMinInputValue(tempMinPrice?.toString() ?? "");
    };
    t8 = [tempMinPrice];
    $[10] = tempMinPrice;
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[13] !== tempMaxPrice) {
    t9 = () => {
      setMaxInputValue(tempMaxPrice?.toString() ?? "");
    };
    t10 = [tempMaxPrice];
    $[13] = tempMaxPrice;
    $[14] = t10;
    $[15] = t9;
  } else {
    t10 = $[14];
    t9 = $[15];
  }
  useEffect(t9, t10);
  let t11;
  if ($[16] !== minPrice || $[17] !== tempMaxPrice || $[18] !== tempMinPrice) {
    t11 = value => {
      const numValue = parseInt(value);
      if (isNaN(numValue) || value.trim() === "") {
        return tempMinPrice;
      }
      return Math.max(minPrice, Math.min(numValue, tempMaxPrice ?? 0));
    };
    $[16] = minPrice;
    $[17] = tempMaxPrice;
    $[18] = tempMinPrice;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const getValidatedMinPrice = t11;
  let t12;
  if ($[20] !== maxPrice || $[21] !== tempMaxPrice || $[22] !== tempMinPrice) {
    t12 = (value_0, t13) => {
      const currentMinPrice = t13 === undefined ? tempMinPrice : t13;
      const numValue_0 = parseInt(value_0);
      if (isNaN(numValue_0) || value_0.trim() === "") {
        return tempMaxPrice;
      }
      return Math.min(maxPrice, Math.max(numValue_0, currentMinPrice ?? 0));
    };
    $[20] = maxPrice;
    $[21] = tempMaxPrice;
    $[22] = tempMinPrice;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const getValidatedMaxPrice = t12;
  let t13;
  if ($[24] !== isMobile || $[25] !== isOpen || $[26] !== tempMaxPrice || $[27] !== tempMinPrice || $[28] !== tempOnSaleOnly) {
    t13 = [isOpen, isMobile, tempMinPrice, tempMaxPrice, tempOnSaleOnly];
    $[24] = isMobile;
    $[25] = isOpen;
    $[26] = tempMaxPrice;
    $[27] = tempMinPrice;
    $[28] = tempOnSaleOnly;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && isOpen && !isMobile) {
        handleApply();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, t13);
  let t14;
  if ($[30] !== getValidatedMinPrice) {
    t14 = value_1 => {
      const validatedValue = getValidatedMinPrice(value_1);
      setTempMinPrice(validatedValue);
      setMinInputValue(validatedValue?.toString() ?? "");
    };
    $[30] = getValidatedMinPrice;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  const validateAndSetMinPrice = t14;
  let t15;
  if ($[32] !== getValidatedMaxPrice) {
    t15 = value_2 => {
      const validatedValue_0 = getValidatedMaxPrice(value_2);
      setTempMaxPrice(validatedValue_0);
      setMaxInputValue(validatedValue_0?.toString() ?? "");
    };
    $[32] = getValidatedMaxPrice;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const validateAndSetMaxPrice = t15;
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = e => {
      const value_3 = e.target.value;
      if (value_3 === "" || /^\d+$/.test(value_3)) {
        setMinInputValue(value_3);
      }
    };
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  const handleMinPriceChange = t16;
  let t17;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = e_0 => {
      const value_4 = e_0.target.value;
      if (value_4 === "" || /^\d+$/.test(value_4)) {
        setMaxInputValue(value_4);
      }
    };
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  const handleMaxPriceChange = t17;
  let t18;
  if ($[36] !== minInputValue || $[37] !== validateAndSetMinPrice) {
    t18 = () => {
      validateAndSetMinPrice(minInputValue);
    };
    $[36] = minInputValue;
    $[37] = validateAndSetMinPrice;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  const handleMinPriceBlur = t18;
  let t19;
  if ($[39] !== maxInputValue || $[40] !== validateAndSetMaxPrice) {
    t19 = () => {
      validateAndSetMaxPrice(maxInputValue);
    };
    $[39] = maxInputValue;
    $[40] = validateAndSetMaxPrice;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  const handleMaxPriceBlur = t19;
  let t20;
  if ($[42] !== minInputValue || $[43] !== validateAndSetMinPrice) {
    t20 = e_1 => {
      if (e_1.key === "Enter") {
        validateAndSetMinPrice(minInputValue);
        e_1.currentTarget.blur();
      }
    };
    $[42] = minInputValue;
    $[43] = validateAndSetMinPrice;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  const handleMinPriceKeyDown = t20;
  let t21;
  if ($[45] !== maxInputValue || $[46] !== validateAndSetMaxPrice) {
    t21 = e_2 => {
      if (e_2.key === "Enter") {
        validateAndSetMaxPrice(maxInputValue);
        e_2.currentTarget.blur();
      }
    };
    $[45] = maxInputValue;
    $[46] = validateAndSetMaxPrice;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  const handleMaxPriceKeyDown = t21;
  let t22;
  if ($[48] !== tempMaxPrice) {
    t22 = e_3 => {
      const value_5 = parseInt(e_3.target.value);
      if (value_5 <= (tempMaxPrice ?? 0)) {
        setTempMinPrice(value_5);
      }
    };
    $[48] = tempMaxPrice;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  const handleMinSliderChange = t22;
  let t23;
  if ($[50] !== tempMinPrice) {
    t23 = e_4 => {
      const value_6 = parseInt(e_4.target.value);
      if (value_6 >= (tempMinPrice ?? 0)) {
        setTempMaxPrice(value_6);
      }
    };
    $[50] = tempMinPrice;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  const handleMaxSliderChange = t23;
  const handleApply = () => {
    const validatedMinPrice = getValidatedMinPrice(minInputValue);
    const validatedMaxPrice = getValidatedMaxPrice(maxInputValue, validatedMinPrice);
    setSelectedMinPrice(validatedMinPrice);
    setSelectedMaxPrice(validatedMaxPrice);
    setShowOnSaleOnly(tempOnSaleOnly);
    if (validatedMinPrice === selectedMinPrice && validatedMaxPrice === selectedMaxPrice) {
      setIsOpen(false);
      return;
    }
    onApplyFilters(allSelectedColors, allSelectedSizes, currentFeatures, validatedMinPrice ?? 0, validatedMaxPrice ?? 0, tempOnSaleOnly);
    setIsOpen(false);
  };
  let t24;
  if ($[52] !== maxPrice || $[53] !== minPrice) {
    t24 = () => {
      setTempMinPrice(minPrice);
      setTempMaxPrice(maxPrice);
      setTempOnSaleOnly(false);
      setMinInputValue(minPrice.toString());
      setMaxInputValue(maxPrice.toString());
    };
    $[52] = maxPrice;
    $[53] = minPrice;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  const handleClear = t24;
  let t25;
  if ($[55] !== isOpen) {
    t25 = () => {
      setIsOpen(!isOpen);
    };
    $[55] = isOpen;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  const toggleDropdown = t25;
  const hasChanges = selectedMinPrice !== minPrice || selectedMaxPrice !== maxPrice || showOnSaleOnly === true;
  let t26;
  if ($[57] !== maxPrice || $[58] !== minPrice) {
    t26 = value_7 => (value_7 - minPrice) / (maxPrice - minPrice) * 100;
    $[57] = maxPrice;
    $[58] = minPrice;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  const getPercent = t26;
  const minPercent = getPercent(tempMinPrice ?? 0);
  const maxPercent = getPercent(tempMaxPrice ?? 0);
  let t27;
  if ($[60] !== currency || $[61] !== handleApply || $[62] !== handleClear || $[63] !== handleMaxPriceBlur || $[64] !== handleMaxPriceChange || $[65] !== handleMaxPriceKeyDown || $[66] !== handleMaxSliderChange || $[67] !== handleMinPriceBlur || $[68] !== handleMinPriceChange || $[69] !== handleMinPriceKeyDown || $[70] !== handleMinSliderChange || $[71] !== isMobile || $[72] !== maxInputValue || $[73] !== maxPercent || $[74] !== maxPrice || $[75] !== minInputValue || $[76] !== minPercent || $[77] !== minPrice || $[78] !== tempMaxPrice || $[79] !== tempMinPrice || $[80] !== tempOnSaleOnly) {
    t27 = () => <><div className="flex items-center gap-4 mb-4"><div className="flex-1"><Text text="Cena od" fontSize={TextSize.XS} color={TextColor.GRAYSCALE_600} /><div className="flex items-center gap-2"><Input type="text" value={minInputValue} onChange={handleMinPriceChange} onBlur={handleMinPriceBlur} onKeyDown={handleMinPriceKeyDown} max={Number(maxPrice)} id="min-price" name="min-price" placeholder="Cena od" icon={false} iconBackground={false} className={`${isMobile ? "!w-1/2" : "!w-14"}`} /><Text text={currency} fontSize={TextSize.S} color={TextColor.GRAYSCALE_500} /></div></div><div className="flex-1"><Text text="Cena do" fontSize={TextSize.XS} color={TextColor.GRAYSCALE_600} /><div className="flex items-center gap-2"><Input type="text" value={maxInputValue} onChange={handleMaxPriceChange} onBlur={handleMaxPriceBlur} onKeyDown={handleMaxPriceKeyDown} max={Number(maxPrice)} id="max-price" name="max-price" placeholder="Cena do" icon={false} iconBackground={false} className={`${isMobile ? "!w-1/2" : "!w-14"}`} /><Text text={currency} fontSize={TextSize.S} color={TextColor.GRAYSCALE_500} /></div></div></div><RangeSliderContainer><SliderTrack /><SliderRange $left={minPercent} $width={maxPercent - minPercent} /><MinRangeInput type="range" min={minPrice} max={maxPrice} value={tempMinPrice ?? 0} onChange={handleMinSliderChange} /><MaxRangeInput type="range" min={minPrice} max={maxPrice} value={tempMaxPrice ?? 0} onChange={handleMaxSliderChange} /></RangeSliderContainer><div className="mb-4"><label className="flex items-center cursor-pointer group"><input type="checkbox" checked={tempOnSaleOnly} onChange={e_5 => setTempOnSaleOnly(e_5.target.checked)} className="absolute w-px h-px p-0 -m-px overflow-hidden clip-[rect(0,0,0,0)] whitespace-nowrap border-0" /><div className={`w-5 h-5 border-2 flex items-center justify-center transition-all duration-200 group-hover:border-gray-400 ${tempOnSaleOnly ? "border-black bg-black" : "border-gray-300 bg-white"}`}>{tempOnSaleOnly && <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" /></svg>}</div><span className="ml-3"><Text text="Tylko promocje" fontSize={TextSize.S} weight={TextWeight.NORMAL} color={TextColor.GRAYSCALE_700} /></span></label></div><div className="flex gap-2"><Button text={"Wyczy\u015B\u0107"} fullWidth={true} className="!w-full" size={ButtonSize.S} onClick={handleClear} variant={ButtonVariant.SECONDARY} /><Button text="Zastosuj" fullWidth={true} className="!w-full" size={ButtonSize.S} onClick={handleApply} /></div></>;
    $[60] = currency;
    $[61] = handleApply;
    $[62] = handleClear;
    $[63] = handleMaxPriceBlur;
    $[64] = handleMaxPriceChange;
    $[65] = handleMaxPriceKeyDown;
    $[66] = handleMaxSliderChange;
    $[67] = handleMinPriceBlur;
    $[68] = handleMinPriceChange;
    $[69] = handleMinPriceKeyDown;
    $[70] = handleMinSliderChange;
    $[71] = isMobile;
    $[72] = maxInputValue;
    $[73] = maxPercent;
    $[74] = maxPrice;
    $[75] = minInputValue;
    $[76] = minPercent;
    $[77] = minPrice;
    $[78] = tempMaxPrice;
    $[79] = tempMinPrice;
    $[80] = tempOnSaleOnly;
    $[81] = t27;
  } else {
    t27 = $[81];
  }
  const renderContent = t27;
  const t28 = hasChanges ? TextWeight.BOLD : TextWeight.NORMAL;
  let t29;
  if ($[82] !== priceLabel || $[83] !== t28) {
    t29 = <Text text={priceLabel} fontSize={TextSize.XS} textTransform="uppercase" className="tracking-widest" weight={t28} />;
    $[82] = priceLabel;
    $[83] = t28;
    $[84] = t29;
  } else {
    t29 = $[84];
  }
  const t30 = `w-4 h-4 text-gray-500 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`;
  let t31;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />;
    $[85] = t31;
  } else {
    t31 = $[85];
  }
  let t32;
  if ($[86] !== t30) {
    t32 = <svg className={t30} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">{t31}</svg>;
    $[86] = t30;
    $[87] = t32;
  } else {
    t32 = $[87];
  }
  let t33;
  if ($[88] !== t29 || $[89] !== t32 || $[90] !== toggleDropdown) {
    t33 = <div className="w-fit flex items-center justify-between gap-2 cursor-pointer transition-colors duration-200" onClick={toggleDropdown}>{t29}{t32}</div>;
    $[88] = t29;
    $[89] = t32;
    $[90] = toggleDropdown;
    $[91] = t33;
  } else {
    t33 = $[91];
  }
  let t34;
  if ($[92] !== handleApply || $[93] !== isMobile || $[94] !== isOpen || $[95] !== renderContent) {
    t34 = isMobile ? <SwipeableDrawer anchor="bottom" open={isOpen} onClose={() => handleApply()} onOpen={() => setIsOpen(true)} disableSwipeToOpen={false} ModalProps={{
      keepMounted: true
    }}><div className="p-4"><div className="flex justify-end cursor-pointer" onClick={() => setIsOpen(false)}><Close /></div>{renderContent()}</div></SwipeableDrawer> : isOpen && <div className="absolute top-8 left-0 border border-gray-200 bg-white min-w-80 p-4 z-10">{renderContent()}</div>;
    $[92] = handleApply;
    $[93] = isMobile;
    $[94] = isOpen;
    $[95] = renderContent;
    $[96] = t34;
  } else {
    t34 = $[96];
  }
  let t35;
  if ($[97] !== t33 || $[98] !== t34) {
    t35 = <div className="relative" ref={dropdownRef}>{t33}{t34}</div>;
    $[97] = t33;
    $[98] = t34;
    $[99] = t35;
  } else {
    t35 = $[99];
  }
  return t35;
};
export default Pricing;